import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { getQueryConfig } from 'src/features/price-policies/constants'

export const getVersionByModelName = async (params) => {

    const {carLots, modelNames} = params
    let query = ''
    carLots.forEach(id => {
        query = query + 'car_lot_id[]=' + id + '&'
    })

    if (!modelNames) return

    modelNames.forEach(modelName => {
        query = query + 'modelName[]=' + modelName + '&'
    })

    query = query.slice(0, -1)

    const queryConfig = getQueryConfig(params)

    const { data } = await axios(
        `${REACT_APP_API}/bonifications/versionsForBonification?${query}&${queryConfig}`
    )

    return data
}
